module.exports = __webpack_public_path__ + "static/media/mobile-contact-card.5cf8bd4f.png";